export const SORT_TYPE = 'Order.Direction';
export const SORT_KEY = 'Order.Key';
export const SEARCH_QUERY = 'Search';